import React from 'react'
import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { courseAccessLocaleKeys } from '../../../constants/course'
import { CourseAccessTypeEnum } from '../../../types/course'
import { Radio } from '../../../ui-lib/radio'

interface CourseAccessSelectProps {
  onChangeAccessType: (value: CourseAccessTypeEnum) => void
  type:
    | AutomationRuleActionsEnum.enroll_in_course_bundle
    | AutomationRuleActionsEnum.enroll_in_course
  value: CourseAccessTypeEnum
}

export const CourseAccessSelect = ({
  onChangeAccessType,
  type,
  value,
}: CourseAccessSelectProps) => {
  const { t } = useTypedTranslation()

  return (
    <div className="mt-2 flex flex-col gap-1">
      <Radio
        name={`${type}-full-access-type`}
        isChecked={value === CourseAccessTypeEnum.fullAccess}
        onChange={() => onChangeAccessType(CourseAccessTypeEnum.fullAccess)}
      >
        {t(courseAccessLocaleKeys[CourseAccessTypeEnum.fullAccess])}
      </Radio>
      <Radio
        name={`${type}-dripping-content-access-type`}
        isChecked={value === CourseAccessTypeEnum.drippingContent}
        onChange={() =>
          onChangeAccessType(CourseAccessTypeEnum.drippingContent)
        }
      >
        {t(courseAccessLocaleKeys[CourseAccessTypeEnum.drippingContent])}
      </Radio>
    </div>
  )
}
